/* tslint:disable */
/* eslint-disable */
/**
 * Local Map - Local Map Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.3
 * Contact: local-map@daangn.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../runtime';
/**
 * 
 * @export
 * @interface GetAddressByCoordinateResponseAddressLand
 */
export interface GetAddressByCoordinateResponseAddressLand {
    /**
     * 
     * @type {string}
     * @memberof GetAddressByCoordinateResponseAddressLand
     */
    fullAddress: string;
    /**
     * 
     * @type {string}
     * @memberof GetAddressByCoordinateResponseAddressLand
     */
    shortAddress: string;
}

/**
 * Check if a given object implements the GetAddressByCoordinateResponseAddressLand interface.
 */
export function instanceOfGetAddressByCoordinateResponseAddressLand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fullAddress" in value;
    isInstance = isInstance && "shortAddress" in value;

    return isInstance;
}

export function GetAddressByCoordinateResponseAddressLandFromJSON(json: any): GetAddressByCoordinateResponseAddressLand {
    return GetAddressByCoordinateResponseAddressLandFromJSONTyped(json, false);
}

export function GetAddressByCoordinateResponseAddressLandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAddressByCoordinateResponseAddressLand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fullAddress': json['full_address'],
        'shortAddress': json['short_address'],
    };
}

export function GetAddressByCoordinateResponseAddressLandToJSON(value?: GetAddressByCoordinateResponseAddressLand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'full_address': value.fullAddress,
        'short_address': value.shortAddress,
    };
}

